<template>
	<!-- 전체 타이틀 및 큰이미지들을 표시하고 설명(타이틀) 및 설명 (세부 내용)을 표시하는 컴포넌트 -->
	<div class="multiImageNTextComponent">

		<!-- 옵션 -->
		<OptionEditor title="전체 옵션" :option="option" message="각 옵션은 컴포넌트 전체에 적용됩니다." />

		<!-- 타이틀 옵션 -->
		<OptionEditor title="타이틀 옵션" :option="title.option" />
		<!-- 타이틀 -->
		<template v-if="optionGetArray(title.option,'show').value&&title.text">
			<TextContentEdit v-if="optionGetArray(title.option,'show').value" title bold :textData="title"/>
		</template>

		<!-- 이미지 -->
		<div>
			<!-- 이미지 옵션 -->
			<OptionEditor title="이미지 옵션" :option="image.option" />
			<ul class="imgList" v-if="image.items">
				<li
					v-for="(item, idx) in image.items"
					:key="idx"
					class="typeBoardImg"
					:class="[
						optionGetArray(option,'column')?'col'+optionGetArray(option,'column').value:'',
						// 추가 옵션
						{'onPadding' : optionGetArray(option,'onPadding')?optionGetArray(option,'onPadding').value:false},
						{'vAlignCenter' : optionGetArray(image.option,'align').value==='vcenter'},
						{'hAlignCenter' : optionGetArray(image.option,'align').value==='hcenter'},
					]"
				>
					<router-link
						v-if="item.link"
						:to="item.link"
					>
						<img :src="uploadedFiles[idx]?$store.getters.getUrlPrefix+'/resources/data/uploadTest/'+uploadedFiles[idx].fileName:$store.getters.getUrlPrefix+imgUrlSelect(image.items[idx].url)" :alt="item.alt">
					</router-link>
					<img
						v-else
						:src="uploadedFiles[idx]?$store.getters.getUrlPrefix+'/resources/data/uploadTest/'+uploadedFiles[idx].fileName:$store.getters.getUrlPrefix+imgUrlSelect(image.items[idx].url)"
						:alt="item.alt"
					>
					<b-upload
						class="fileUploader"
						v-model="dropFiles[idx]"
						drag-drop
						type="is-white"
						@input="fileSingleUpload($event, idx)"
					>
						<section class="section">
							<div class="content has-text-centered">
								<p>
									<b-icon
										icon="upload"
										size="is-large">
									</b-icon>
								</p>
								<p class="is-size-6" v-if="uploadedFiles[idx]">{{dropFiles[idx].name}}</p>
								<p class="is-size-6" v-else>파일 업로드<br>드래그앤드랍<br>or 클릭)</p>
							</div>
						</section>
					</b-upload>
					<b-button class="btnDeleteUploaded" v-if="uploadedFiles[idx]" @click="deleteUploadedFile($event, idx)">업로드 파일 제거</b-button>
				</li>
			</ul>
			<!-- 이미지 추가 버튼 -->
			<div class="control buttons">
				<b-button class="button" @click="addNewFile" icon-left="plus">이미지 추가</b-button>
			</div>
		</div>

		<!-- 텍스트 옵션 -->
		<OptionEditor title="텍스트 옵션" :option="text.option" />
		<!-- 텍스트 -->
		<template v-if="optionGetArray(text.option,'show').value&&text.items">
		<div
			v-for="(textList, tlIdx) in text.items"
			:key="tlIdx"
			class="typeBoardTxt"
			:class="{'withHyphen' : optionGetArray(text.option,'hyphen').value}"
		>
			<!-- 타이틀 -->
			<TextContentEdit v-if="textList.title.text" class="typeBoardTxtTitle" :textData="textList.title"/>
			<ul v-if="textList.text">
			<template
				v-for="(item, idx) in textList.text"
			>
				<TextContentEdit :key="idx" tag="li" v-if="item" :textData="item" />
			</template>
			</ul>
		</div>
		</template>
	</div>
</template>

<script>
import { EventBus } from '../utils/event-bus'
import TextContentEdit from './TextContentEdit'
import OptionEditor from './OptionEditor'
export default {
	name: 'multiImageNText',
	components: {
		TextContentEdit,
		OptionEditor
	},
	props: {
		filePath: {
			type: String,
			default: ''
		},
		componentName: {
			type: String,
			default: 'boardItem'
		},
		index: {
			type: Number,
			default: 0
		},
		option: {
			type: Array,
			default: function () {
				return []
			}
		},
		title: {
			type: Object,
			default: function () {
				return {
					uiType: 'input',
					text: '',
					option: [
						/* {
							name: 'optionName',
							type: 'string, number, boolean, ',
							value: value
						} */
					],
					class: '', /* 'className1 className2', ... */
					style: {
						/* color: '#32320a', fontSize: '24px', padding: '20px 10px 20px 5px', margint: '0px auto 20px auto' */
					}
				}
			}
		},
		image: {
			type: Object,
			default: function () {
				return {
					uiType: 'files',
					option: [
						{
							name: 'onPadding',
							type: 'boolean',
							value: true
						}
					],
					items: [
						{
							url: null,
							alt: '',
							link: '',
							target: ''
						}
					]
				}
			}
		},
		text: {
			type: Object,
			default: function () {
				return {
					uiType: 'input',
					id: '',
					option: {
						show: {
							type: 'boolean',
							value: true
						},
						hyphen: {
							type: 'boolean',
							value: false
						}
					},
					items: [
						{
							title: {
								uiType: 'input',
								text: '',
								class: '', /* 'className1 className2', ... */
								style: {
									/* color: '#32320a', fontSize: '24px', padding: '20px 10px 20px 5px', margint: '0px auto 20px auto' */
								}
							},
							text: [
								{
									uiType: 'input',
									text: '',
									class: '', /* 'className1 className2', ... */
									style: {
										/* color: '#32320a', fontSize: '24px', padding: '20px 10px 20px 5px', margint: '0px auto 20px auto' */
									}
								}
							],
							link: '',
							target: ''
						}
					]
				}
			}
		}
	},
	data () {
		return {
			modal: '',
			dropFiles: [],
			oldFiles: [],
			uploadedFiles: [],
			uploadFileName: '',
			fileIndex: null
		}
	},
	watch: {
		option: {
			deep: true,
			immediate: true,
			handler () {
				console.log('The option data has changed!')
			}
		},
		uploadedFiles: {
			deep: true,
			immediate: true,
			handler () {
				console.log('The files data has changed!')
			}
		}
	},
	created () {},
	destroyed () {
		EventBus.$off('send-form-ready-start')
	},
	mounted () {
		EventBus.$on('send-form-ready-start', (data) => {
			console.log('**MultiImageNTextEdit > 파일 쓰기 시작')
			for (var idx in this.uploadedFiles) {
				if (this.uploadedFiles[idx]) {
					// 수정 파일 있음.
					if (this.uploadedFiles[idx].fileName) {
						this.image.items[idx].url = this.filePath + this.uploadedFiles[idx].fileName
					}
				}
			}
		})
	},
	computed: {},
	methods: {
		imgUrlSelect (item) {
			var itemType = typeof (item)
			var urlObj
			var url
			if (itemType === 'string') {
				urlObj = { pc: item, tablet: item, mobile: item }
			} else if (itemType === 'object') {
				urlObj = item
			}
			if (this.$store.state.device === 'pc') {
				url = urlObj.pc ? urlObj.pc : ''
			} else if (this.$store.state.device === 'tablet') {
				url = urlObj.tablet ? urlObj.tablet : urlObj.pc
			} else if (this.$store.state.device === 'mobile') {
				url = urlObj.mobile ? urlObj.mobile : urlObj.pc
			}
			return url
		},
		fileSingleUpload (e, idx) {
			this.uploadFileName = e.name
			this.fileIndex = idx
			let oldUrl = this.image.items[idx]
			if (!this.oldFiles[idx]) {
				this.oldFiles[idx] = oldUrl
			}
			EventBus.$on('file-upload-complete' + this.uploadFileName.split('.').slice(0, -1).join('.') + this.fileIndex, (data) => {
				console.log('---------> 파일 업로드 후 콜백 완료 : ' + this.uploadFileName + ' / ' + this.fileIndex)
				console.log('파일 업로드 후 콜백 데이터 :', data)
				this.uploadedFiles[data.idx] = {
					fileName: data.file
				}
				var tempArray = this.uploadedFiles
				this.uploadedFiles = []
				this.uploadedFiles = tempArray

				EventBus.$off('file-upload-complete' + this.uploadFileName.split('.').slice(0, -1).join('.') + this.fileIndex)
			})
			EventBus.$emit('file-upload', { file: e, orgFileWithPath: this.imgUrlSelect(this.image.items[idx].url), idx: this.fileIndex })
		},
		deleteUploadedFile (e, idx) {
			console.log('* func: deleteUploadedFile:', idx)
			EventBus.$emit('file-delete', { file: this.uploadedFiles[idx].fileName, idx: idx })
			this.uploadedFiles.splice(idx, 1)
			this.dropFiles[idx] = {}

			// new file check
			if (this.oldFiles[idx]) {
				if ((this.oldFiles[idx].url === '') || (this.oldFiles[idx].url.pc === '' || this.oldFiles[idx].url.tablet === '' || this.oldFiles[idx].url.mobile === '')) {
					// console.log('*-> 기존파일 없음')
					this.image.items.splice(idx, 1)
					this.oldFiles.splice(idx, 1)
				} else {
					// console.log('*-> 기존파일 존제')
					if (typeof (this.image.items[idx].url) === 'string') {
						this.image.items[idx].url = this.oldFiles[idx].url
					} else if (typeof (this.image.items[idx].url) === 'object') {
						this.image.items[idx].url.pc = this.oldFiles[idx].url.pc
					}
					this.oldFiles.splice(idx, 1)
				}
			}
			// 삭제 파일 이외의 파일 미리 보기 재설정
			for (var oldFile in this.oldFiles) {
				if (this.oldFiles[oldFile]) {
					if (typeof (this.image.items[oldFile].url) === 'string') {
						this.image.items[oldFile].url = this.oldFiles[oldFile].url
					} else if (typeof (this.image.items[oldFile].url) === 'object') {
						this.image.items[oldFile].url.pc = this.oldFiles[oldFile].url.pc
					}
				}
			}
		},
		addNewFile (e) {
			console.log(' *func: addNewFile: ', e)

			if (this.image.items[this.image.items.length - 1].url) {
				this.image.items.push({
					url: {
						pc: '',
						tablet: '',
						mobile: ''
					},
					alt: '',
					link: '',
					target: ''
				})
			}
		},
		optionGetArray (obj, name) {
			var tgArray = []
			for (var arrItem in obj) {
				tgArray.push(obj[arrItem])
			}
			var idx = tgArray.findIndex(function (opt) {
				return opt.name === name
			})
			var result = obj[idx]
			return result
		}
	}
}
</script>

<style lang="scss"> // scoped
@import '@/css/variables.scss';
.icon { margin-left: 10px;}
.editStateWrap {
	padding: 20px;
	border-radius: 6px;
	border: 1px solid rgb(223, 223, 223);
	background-color: rgb(247, 247, 247);
	hr {
		border-bottom: 1px solid $c-gray-light2;
	}
	.buttons {
		border-top: 1px solid $c-gray-dark;
		padding: 20px 0 0;
		margin-top: 20px;
	}
}
.inputTitle {
	min-width: $mnWMobile;
}
.strech {
	align-content: stretch;
}
.btnDeleteItem {
	vertical-align: middle;
}
.fileUploader {
	position: absolute;
	display: block;
	width: calc(100% - 20px);
	height: calc(100% - 20px);
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	color: $c-white;
	&.upload .upload-draggable {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-color: rgba($c-black, 0.24);
		min-width: 200px;
	}
}
.btnDeleteUploaded {
	position: absolute;
	bottom: 20px;
	left: 50%;
	transform: translateX(-50%);
}
.multiImageNTextComponent {
	margin-bottom: 80px;
	.imgList {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		.typeBoardImg {
			width: 100%;
			position: relative;
			margin-bottom: 20px;
			img {
				display: block;
				width: 100%;
			}
			&.vAlignCenter {
				height: 400px;
				width: 100%;
				background-color: $c-gray-bright;
				overflow: hidden;
				img {
					position: absolute;
					width: 100% !important; height: auto !important;
					top: 50%; left: 50%;
					transform: translate(-50%, -50%);
				}
			}
			&.hAlignCenter {
				height: 400px;
				width: 100%;
				background-color: $c-gray-bright;
				overflow: hidden;
				img {
					position: absolute;
					width: auto !important; height: 100% !important;
					top: 50%; left: 50%;
					transform: translate(-50%, -50%);
					max-width: none;
				}
			}
			&.col2,
			&.col4 {
				width: 49%;
				img {
					height: auto;
				}
			}
			&.col3 {
				width: 32%;
			}
			&.col4 {
				margin-bottom: 24px;
				&:nth-last-child(1),
				&:nth-last-child(2) {
					margin-bottom: 0;
				}
			}
			&.onPadding {
				padding: 0 14%;
			}
		}
		& + .typeBoardTxt {
			margin-top: 50px;
		}
	}
}
.typeBoardTitle {
	display: block;
	margin-bottom: 24px;
	font-size: $text-medium;
	font-weight: bold;
	.icon {
		display: none;
	}
	&:hover .icon {
		display: inline-block;
	}
}
.typeBoardTxt {
	margin-bottom: 20px;
	&:last-child {
		margin-bottom: 0;
	}
	.typeBoardTxtTitle {
		display: block;
		letter-spacing: $lspace-short;
		font-size: $title-tiny;
		& + .rowspan {
			margin-top: 16px;
		}
	}
	.rowspan {
		display: block;
		color: $c-gray-dark;
	}
	&.withHyphen {
		.rowspan {
			position: relative;
			padding-left: 10px;
			&::before {
				display: block;
				position: absolute;
				left: 0;
				content: '-';
			}
		}
	}
}

.withHyphen .boardComponentTextField:not(.typeBoardTxtTitle) span.txtCont {
	&::before {
		display: inline-block;
		margin-right: 5px;
		content: '-';
	}
}

/*
	##Device = Laptops, Desktops
	##Screen = B/w 1025px to 1280px
*/
@media (min-width: 1025px) and (max-width: 1280px) {
	//CSS
}

/*
	##Device = Tablets, Ipads (portrait)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) {
	//CSS
}

/*
	##Device = Tablets, Ipads (landscape)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  //CSS
}

/*
	##Device = Low Resolution Tablets, Mobiles (Landscape)
	##Screen = B/w 481px to 767px
*/
@media (min-width: 650px) and (max-width: 767px) {
	//css
}

// 미세조정
@media (min-width: 481px) and (max-width: 649px) {
	.typeBoard {
		&Wrap {
			.imgList {
				$multiple: 2.04;
				$w: 100%;
				.typeBoardImg {
					display: inline-block;
					width: $w;
					img {
						width: $w;
					}

					&.col2,
					&.col3,
					&.col4 {
						width: $w/$multiple;
					}
					&.col3 {
						&:nth-child(3) {
							width: $w;
							margin-top: 12px;
						}
					}
					&.col4 {
						&:nth-last-child(1),
						&:nth-last-child(2) {
							margin-top: 12px;
						}
					}
					&.onPadding {
						padding: 0;
					}
				}
				& + .typeBoardTxt {
					margin-top: 15px;
				}
			}
		}
		&Title {
			margin-bottom: 12px;
			font-size: $title-xsmall;
		}
		&Txt {
			.typeBoardTxtTitle {
				font-size: $title-xtiny;
				& + .rowspan {
					margin-top: 8px;
				}
			}
			.rowspan {
				font-size: $text-tiny;

				&+.rowspan {
					padding-top: 2px;
				}
			}
		}
	}
}

/*
	##Device = Most of the Smartphones Mobiles (Portrait)
	##Screen = B/w 320px to 479px
*/
@media (min-width: $mnWMobile) and (max-width: 480px) {
	//CSS
	.typeBoard {
		&Wrap {
			.imgList {
				$w: 100%;
				// display: block;
				// flex-wrap: unset;
				// justify-content: unset;
				.typeBoardImg {
					width: $w;
					img {
						width: $w;
					}

					&.col2,
					&.col3,
					&.col4 {
						width: $w;
						margin-top: 12px;
						&:first-child {
							margin-top: 0;
						}
					}
					&.col4 {
						margin-bottom: 0;
						&:nth-last-child(1),
						&:nth-last-child(2) {
							margin-bottom: 0;
						}
					}
					&.onPadding {
						padding: 0;
					}
				}
				& + .typeBoardTxt {
					margin-top: 15px;
				}
			}
		}
		&Title {
			margin-bottom: 12px;
			font-size: $title-xsmall;
		}
		&Txt {
			.typeBoardTxtTitle {
				font-size: $title-xtiny;
				& + .rowspan {
					margin-top: 8px;
				}
			}
			.rowspan {
				font-size: $text-tiny;

				&+.rowspan {
					padding-top: 2px;
				}
			}
		}
	}
}
</style>
